import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('ReceptionDetails', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  receptionDetails: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  receptionDetails: state => state.receptionDetails
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
